import React from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import moment from "moment";

const StockMonthlyTotal = (props) => {
  return (
    <Widgets
      icon="calendar-new"
      currency={`01-${moment().format("DD MMMM")}`}
      title="Bu Ay Eklenen Stok Sayısı"
      totalBalance={
        <CurrencyFormat
          value={props?.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={""}
        />
      }
    />
  );
};

export default StockMonthlyTotal;
